export const url = {
    alicanto :process.env.REACT_APP_ALICANTO_SERVICE}